// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------
   CloudGenomics SuperAdmin — Organizations Page Styles
   Contemporary, enterprise-grade, clean, and highly polished
----------------------------------------------------------- */

/* Page container */
.org-page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
    sans-serif;
  color: #1f2937;
}

/* Headings */
.org-page-container h1 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #111827;
}

.org-page-container p {
  font-size: 15px;
  color: #4b5563;
  margin-bottom: 24px;
}

/* Section title */
.section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 32px 0 16px;
  color: #111827;
}

/* Table container */
.org-table-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow-x: auto;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

/* Table */
.org-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.org-table thead {
  background: #f9fafb;
}

.org-table th {
  text-align: left;
  padding: 14px 18px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.org-table td {
  padding: 14px 18px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

/* Hover effect */
.org-table tbody tr:hover {
  background: #f9fafb;
}

/* Buttons */
.btn {
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.15s ease;
  margin-left: 12px;
}

.btn-approve {
  background: #2563eb;
  color: white;
}

.btn-approve:hover {
  background: #1e4fcf;
}

.btn-warning {
  background: #df6c00;
  color: white;
}

.btn-warning:hover {
  background: #df6c00;
}

.btn-secondary {
  background: #366e4c;
  color: white;
}

.btn-secondary:hover {
  background: #366e4c;
}

.btn-reject {
  background: #dc2626;
  color: white;
}

.btn-reject:hover {
  background: #b91c1c;
}

/* Empty state */
.empty-state {
  padding: 32px;
  text-align: center;
  color: #6b7280;
  font-size: 15px;
}

/* Loading */
.loading-text {
  padding: 16px;
  font-size: 15px;
  color: #4b5563;
}

/* Smooth fade-in */
.fade-in {
  animation: fadeIn 0.25s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.form-input {
  width: 100%;
  padding: 10px;
  margin-top: 6px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
}

.modal select.form-input[multiple] {
  height: 120px;
}

/* Modal size */
.modal-lg {
  width: 80%;
  max-width: 1200px;
  max-height: 80vh;
  overflow-y: auto;
}

/* Two-column grid */
.modal-body-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

/* Section styling */
.modal-section {
  background: #fafafa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #eee;
}

.modal-section-full {
  background: #fafafa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #eee;
  margin-bottom: 24px;
}

/* Input styling */
.form-input {
  width: 90%;
  padding: 10px;
  margin-top: 6px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
}

.success-banner {
  background: #e6ffed;
  border: 1px solid #8de4a1;
  color: #0f5132;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations.css"],"names":[],"mappings":"AAAA;;;6DAG6D;;AAE7D,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb;;cAEY;EACZ,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* -----------------------------------------------------------\n   CloudGenomics SuperAdmin — Organizations Page Styles\n   Contemporary, enterprise-grade, clean, and highly polished\n----------------------------------------------------------- */\n\n/* Page container */\n.org-page-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\",\n    sans-serif;\n  color: #1f2937;\n}\n\n/* Headings */\n.org-page-container h1 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #111827;\n}\n\n.org-page-container p {\n  font-size: 15px;\n  color: #4b5563;\n  margin-bottom: 24px;\n}\n\n/* Section title */\n.section-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 32px 0 16px;\n  color: #111827;\n}\n\n/* Table container */\n.org-table-wrapper {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow-x: auto;\n  max-width: 100%;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n}\n\n/* Table */\n.org-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.org-table thead {\n  background: #f9fafb;\n}\n\n.org-table th {\n  text-align: left;\n  padding: 14px 18px;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.org-table td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n}\n\n/* Hover effect */\n.org-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n/* Buttons */\n.btn {\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.15s ease;\n  margin-left: 12px;\n}\n\n.btn-approve {\n  background: #2563eb;\n  color: white;\n}\n\n.btn-approve:hover {\n  background: #1e4fcf;\n}\n\n.btn-warning {\n  background: #df6c00;\n  color: white;\n}\n\n.btn-warning:hover {\n  background: #df6c00;\n}\n\n.btn-secondary {\n  background: #366e4c;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #366e4c;\n}\n\n.btn-reject {\n  background: #dc2626;\n  color: white;\n}\n\n.btn-reject:hover {\n  background: #b91c1c;\n}\n\n/* Empty state */\n.empty-state {\n  padding: 32px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 15px;\n}\n\n/* Loading */\n.loading-text {\n  padding: 16px;\n  font-size: 15px;\n  color: #4b5563;\n}\n\n/* Smooth fade-in */\n.fade-in {\n  animation: fadeIn 0.25s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  width: 400px;\n}\n\n.modal-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px;\n  margin-top: 6px;\n  margin-bottom: 16px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 15px;\n}\n\n.modal select.form-input[multiple] {\n  height: 120px;\n}\n\n/* Modal size */\n.modal-lg {\n  width: 80%;\n  max-width: 1200px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n/* Two-column grid */\n.modal-body-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n/* Section styling */\n.modal-section {\n  background: #fafafa;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.modal-section-full {\n  background: #fafafa;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #eee;\n  margin-bottom: 24px;\n}\n\n/* Input styling */\n.form-input {\n  width: 90%;\n  padding: 10px;\n  margin-top: 6px;\n  margin-bottom: 16px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 15px;\n}\n\n.success-banner {\n  background: #e6ffed;\n  border: 1px solid #8de4a1;\n  color: #0f5132;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 15px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
